import { render, staticRenderFns } from "./Employers.vue?vue&type=template&id=36575940&"
import script from "./Employers.vue?vue&type=script&lang=js&"
export * from "./Employers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports